
import { ExtraFieldNumberConfig } from "@/models/dossier-configs/extra-field-number-config";
import { IExtraFieldQuickEditViaMenuData, IExtraFieldQuickEditViaMenuDataResult, IExtraFields } from "@/utils/models/extra-fields";
import Vue from "vue";
import { TranslateResult } from "vue-i18n";
import AppExtraFieldsEditText from "@/components/ExtraFieldsEditText.vue";

export default Vue.extend({
	data(){
		return {
			result: {
				boolValue: false,
				numValue: 0,
				textValue: "",
				timeValue: null
			} as IExtraFieldQuickEditViaMenuDataResult,
			sending: false
		};
	},
	props: {
		value: {
			type: Object as ()=>IExtraFieldQuickEditViaMenuData,
		},
		getSelectedExtraFieldsFunc: {
			type: Function,
			required: true
		}
	},
	computed: {
		label():string{
			if (!this.value) return "";
			return this.value.name;
		},
		title():TranslateResult | string{
			if (!this.value) return "";
			return this.$ct("common.browse.quick-edit-extra-fields-label-field", {field: this.value.name});
		},
		isNum():boolean {
			if (!this.value) return false;
			return this.value.field.startsWith("Num");
		},
		isString():boolean {
			if (!this.value) return false;
			return this.value.field.startsWith("Text");
		},
		isBoolean():boolean {
			if (!this.value) return false;
			return this.value.field.startsWith("Bool");
		},
		isDate():boolean {
			if (!this.value) return false;
			return this.value.field.startsWith("Time");
		},
		locale(): string {
			return this.$i18n.locale;
		},
		decimals():number {
			if (!this.isNum) return 0;
			let conf = (this.value.config as ExtraFieldNumberConfig).Decimals;
			return conf;
		}
	},
	watch: {
		value: {
			async handler(){
				if (!this.value) return;
				this.result = {
					boolValue: false,
					numValue: 0,
					textValue: "",
					timeValue: null
				};
				let selectedExtraFields:IExtraFields | null = await this.getSelectedExtraFieldsFunc();
				if (!selectedExtraFields) return;
				let value = (selectedExtraFields as any)[this.value.field];
				if (this.isDate) {
					this.result.timeValue = value;
				}else if (this.isNum){
					this.result.numValue = value;
				}else if (this.isBoolean) {
					this.result.boolValue = value;
				}else if (this.isString){
					this.result.textValue = value;
				}
			}
		}
	},
	methods: {
		async confirm(){
			if (this.sending) return;
			this.sending = true;
			await new Promise((resolve)=>{
				this.$emit("confirm", this.result, resolve);
			});
			this.sending = false;
		},
		cancel(){
			this.$emit("close");
		},
	},
	components: {
		AppExtraFieldsEditText
	}
});

